import { defineComponent as _defineComponent } from 'vue'
interface Props {
  region: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TestimonialsSection',
  props: {
    region: null
  },
  setup(__props: any) {



return { __sfc: true, }
}

})